import React, {PureComponent, Fragment} from 'react';
import Typography from "housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography"
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import Popover from "housecall-ui/dist/DesignSystem/DataDisplay/Popover/Popover"
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import ExpandMoreIcon from 'housecall-ui/dist/IconsAndImages/Icons/ExpandMore'
import MenuItem from 'housecall-ui/dist/DesignSystem/Navigation/Menus/MenuItem'
import MenuList from 'housecall-ui/dist/DesignSystem/Navigation/Menus/MenuList'

const styles = {
    menuButton: {
        width: 170
    }
}

@withStyles(styles)
export default class TasksHeaderPopover extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            anchorEl: null,
            disableFocus: true
        }
    }

    handleClick(event) {
        this.setState({anchorEl: event.currentTarget, open: true, disableFocus: false});
    };

    handleClose(event) {
        this.setState({anchorEl: null, open: false});
    };

    render() {
        const {classes} = this.props

        let title = 'All tasks'
        let menuItemTitle = 'My tasks'

        if (this.props.showMyTasks) {
            title = 'My tasks'
            menuItemTitle = 'All tasks'
        }

        return (
        <Typography variant="h5" style={{marginLeft: 15, paddingTop: 5}}>
                {title}
                <IconButton
                    onClick={(event) => this.handleClick(event)}>
                    <ExpandMoreIcon/>
                </IconButton>
                <Popover
                    anchorEl={this.state.anchorEl}
                    open={this.state.open}
                    onClose={(event) => this.handleClose(event)}
                    anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                    transformOrigin={{horizontal: 'center', vertical: 'top'}}
                >
                    <MenuList role="menu">
                        <MenuItem
                            className={classes.menuButton}
                            onClick={ (event) =>{
                                this.handleClose(event)
                                this.props.taskListToggled()
                            }  } >
                            {menuItemTitle}
                        </MenuItem>
                    </MenuList>
                </Popover>
            </Typography>
        )
    }
}
